import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './app';
import { initKeycloak } from './auth/keycloak';
import { loadRuntimeConfig } from './config';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

// Configuration de l'instance puis état de session, connus avant le premier rendu :
// pas d'écran qui clignote entre « connecté » et « non connecté ».
loadRuntimeConfig()
  .then((config) => initKeycloak(config).catch(() => false))
  .then(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </StrictMode>,
    );
  });
